<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <team-user-target-access :teamId="props.teamId" :userId="props.userId" :isKiosk="true" />
        </div>
    </kiosk-team-details>
</template>

<script lang="ts" setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import TeamUserTargetAccess from '~/components/settings/teams/membership/form/TeamUserTargetAccess.vue';

const props = defineProps<{
    teamId: number;
    userId: number;
}>();
</script>
